import { html, View } from 'rune-ts';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import klass from '@services/MarppleShop/renderApp/pages/SearchResult/SearchResult.module.scss';

type TProps = {
  keyword: string;
  totalCount: number;
};

/**
 * 검색 결과 타이틀 뷰
 * ex) 가나디의 3,665개의 검색 결과
 */
export class DetachedSearchTitleView extends View<TProps> {
  override template() {
    const { totalCount, keyword } = this.data;
    const lang = ET.lang;

    if (lang === 'kr') {
      if (totalCount === 0) {
        return html`<span>
          <span class="${font('32_bold')} ${klass.pointed}">${html.preventEscape(keyword)}</span>의 검색 결과
        </span>`;
      } else {
        return html`<span>
          <span class="${font('32_bold')} ${klass.pointed}">${html.preventEscape(keyword)}</span>의
          <span class="${staticFont('unica_32_bold')} ${klass.pointed}">${totalCount.toLocaleString()}</span
          ><span class="${font('32_bold')} ${klass.pointed}">개</span>의 검색 결과
        </span>`;
      }
    } else if (lang === 'en') {
      if (totalCount === 0) {
        return html`<span>
          result for
          <span class="${font('32_bold')} ${klass.pointed}">${html.preventEscape(keyword)}</span> search
        </span>`;
      } else if (totalCount == 1) {
        return html`<span>
          <span class="${font('32_bold')} ${klass.pointed}">${totalCount.toLocaleString()}</span>
          result for
          <span class="${font('32_bold')} ${klass.pointed}">${html.preventEscape(keyword)}</span> search
        </span>`;
      } else {
        return html`<span>
          <span class="${font('32_bold')} ${klass.pointed}">${totalCount.toLocaleString()}</span>
          results for
          <span class="${font('32_bold')} ${klass.pointed}">${html.preventEscape(keyword)}</span> search
        </span>`;
      }
    } else if (lang === 'jp') {
      if (totalCount === 0) {
        return html`<span>
          <span class="${font('32_bold')} ${klass.pointed}">${html.preventEscape(keyword)}</span> 検索結果
        </span>`;
      } else {
        return html`<span>
          <span class="${font('32_bold')} ${klass.pointed}">${html.preventEscape(keyword)}</span>
          <span class="${staticFont('unica_32_bold')} ${klass.pointed}">${totalCount.toLocaleString()}</span
          ><span class="${font('32_bold')} ${klass.pointed}">個</span>の 検索結果
        </span>`;
      }
    } else {
      throw new Error('Unknown lang');
    }
  }
}
